// ScrollTo extension for Naja
naja.registerExtension({
    initialize: function(naja) {
        naja.uiHandler.addEventListener('interaction', function(event) {
            event.detail.options.sourceElement = event.detail.element;
        });
        naja.addEventListener('success', function(event) {
            var element = event.detail.options.sourceElement;
            if (!element) return;
            var target = $(element).data('scroll-to');
            if (target) {
                if (target === 'top') {
                    goTop();
                } else {
                    goTopOfElement(target);
                }
            }
        });
    }
});
